import {combineReducers} from "@reduxjs/toolkit";
import {authPersistedReducer} from './auth';
import { persistReducer } from 'redux-persist'
import organisationReducer from "./organisationSlice";
import filtersReducer from "./filtersSlice";
import storage from "redux-persist/lib/storage";

const organisationPersistConfig = {
  key: 'organisation',
  storage,
  whitelist: ['selectedOrganisation', 'selectedOrganisations'],
};

const filtersPersistConfig = {
  key: 'filters',
  storage,
  whitelist: ['selectedOwner', 'selectedCreator'],
};
  
const organisationPersistedReducer = persistReducer(organisationPersistConfig, organisationReducer);
const filtersPersistedReducer = persistReducer(filtersPersistConfig, filtersReducer);

const rootReducer = combineReducers({
    auth: authPersistedReducer,
    organisation: organisationPersistedReducer,
    filters: filtersPersistedReducer,
});

export default rootReducer;
